var ko = require('knockout');

function LiteratureItemViewModel(data) {
    var self = this;

    self.name = ko.observable(data.name);
    self.id = ko.observable(data.id);
    self.itemId = ko.observable(data.itemId);
    self.formNumber = ko.observable(data.formNumber);
    self.description = ko.observable(data.description);
    self.url = ko.observable(data.url);
    self.target = ko.observable(data.target);
    self.rel = ko.observable(data.rel);
    self.quantity = ko.observable(parseInt(data.quantity));
    self.orderable = ko.observable(data.orderable);
    self.linkType = ko.observable(data.linkType);
    self.parentName = ko.observable(data.parentName);

    self.linkText = ko.computed(function() {
        return (self.parentName() ? self.parentName() + " - " : "") + self.name() + (self.formNumber().length ? " - " + self.formNumber() : "");
    }, this);

    self.linkTextWithoutParent = ko.computed(function () {
        return self.name() + (self.formNumber().length ? " - " + self.formNumber() : "");
    }, this);

    self.linkTextWithoutParentAddQuantityOrder = ko.computed(function () {
        return self.linkTextWithoutParent() + " order quantity";
    }, this);

    self.iconClass = ko.computed(function() {
        switch (self.linkType()) {
            case 'pdf':
                return 'fa-file-pdf';
            case 'doc':
                return 'fa-regular fa-file-word';
            case 'xls':
                return 'fa-regular fa-file-excel';
            case 'external':
                return 'fa-arrow-up-right-from-square';
            default:
                return 'fa-code';
        }
    }, this);
}

module.exports = LiteratureItemViewModel;